import { Col, Stack, Container } from "react-bootstrap";
import { useMemo, useState } from "react";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import ExportData from "../../components/ExportData";
import useSortableData from "../../components/useSortableData";
import SongSearchInput from "../SearchInput";
import DashboardMusicScoresTrendHeader from "./SongScoreTrendsHeader";
import EmptyRow from "../EmptyRow";
import DashboardMusicScoresTrendRow from "./SongScoreTrendRow";
import { getScoreTrendLabel } from "../HelperFunctions";
import SongCatalogueModal from "../songCatalogue/SongCatalogueModal";

export default function MostPlayedSongScoresTable({ data, loading, error }) {
    const [catalogueSong, setCatalogueSong] = useState(null);
    const [filterData, setFilterData] = useState({ searchString: "" });

    const songsMemo = useMemo(() => {
        if (data) {
            let filteredData = data.songs;
            if (filterData.searchString) {
                filteredData = filteredData.filter(
                    x =>
                        x.song.artist.toLowerCase().includes(filterData.searchString.toLowerCase().trim()) ||
                        x.song.title.toLowerCase().includes(filterData.searchString.toLowerCase().trim())
                );
            }
            return filteredData;
        }
    }, [data, filterData.searchString]);

    const { sortedItems, requestSort, sortConfig } = useSortableData(songsMemo);

    const csvHeaders = ["Artist", "Title", "Month", "Week", "Trend", "Week -1", "Week -2", "Week -3"];
    const csvData = useMemo(() => {
        if (!sortedItems) return [];
        return sortedItems.map(x => [
            x.song.artist,
            x.song.title,
            x.music_test_data.song_score_month,
            x.music_test_data.song_score,
            getScoreTrendLabel(x.music_test_data.song_score_trend),
            x.music_test_data.song_score_week_1,
            x.music_test_data.song_score_week_2,
            x.music_test_data.song_score_week_3,
        ]);
    }, [sortedItems]);

    return (
        <>
            {loading ? (
                <LoadingIndicator width={75} />
            ) : error ? (
                <ErrorResponse errorCode={error} />
            ) : (
                data && (
                    <>
                        <Stack direction="horizontal" gap={2} className=" mb-2 flex-wrap-reverse">
                            <Col xs xl={5}>
                                <SongSearchInput filterData={filterData} setFilterData={setFilterData} />
                            </Col>
                            <Col xs={"auto"} className="ms-auto">
                                <Stack direction="horizontal" gap={1} className="ms-xl-auto w-100 w-xl-auto order-first order-xl-last">
                                    <span className="me-1 d-none d-md-inline-block">Download:</span>
                                    <ExportData data={csvData} headers={csvHeaders} filename={`Most Played Song Scores`} />
                                </Stack>
                            </Col>
                        </Stack>
                        <DashboardMusicScoresTrendHeader sortConfig={sortConfig} requestSort={requestSort} />
                        <Container fluid>
                            {sortedItems?.length ? (
                                sortedItems.map(x => <DashboardMusicScoresTrendRow key={x.song.item_id} item={x} setCatalogueSong={setCatalogueSong} />)
                            ) : (
                                <EmptyRow text="No Songs" />
                            )}
                        </Container>
                    </>
                )
            )}
            <SongCatalogueModal show={!!catalogueSong} onHide={() => setCatalogueSong(null)} song={catalogueSong} />
        </>
    );
}
